module.exports = __webpack_public_path__ + "static/img/nest-off.faf8189.png";